﻿<script setup>
    import { Platform } from 'quasar'
    const props = defineProps({
        title: String,
        icon: String,
        size: String,
        nopad: Boolean
    });

    const width = computed(() => {
        if (Platform.is.mobile) return '100%';
        if (props.size == 'xs') return '360px';
        if (props.size == 'sm') return '640px';
        if (props.size == 'md') return '768px';
        if (props.size == 'lg') return '1024px';
        if (props.size == 'xl') return '1280px';
        return '768px';
    })
</script>

<template>
    <q-card :style="{'min-width': width}" flex flex-col>
        <q-bar class="bg-primary text-white">
            <q-icon :name="icon" v-if="icon" mr-2 />
            <span text-sm>{{title}}</span>
            <q-space />
            <slot name="header"></slot>
        </q-bar>

        <q-card-section :class="['window-content grow', {'p-0':nopad}]">
            <slot></slot>
        </q-card-section>

        <q-separator />
        
        <q-card-actions align="around" bottom-0>
            <slot name="actions"></slot>
        </q-card-actions>
    </q-card>
</template>

<style lang="scss">
    .window-content {
        max-height:800px;
        overflow-y:scroll;
    }
</style>